import React from 'react';
import Skeleton from 'wsm-skeleton';

const ImageSkeleton = () => (
	<Skeleton
		skeletonClasses="w-100"
		aspectRatio="4by3"
		dataTestId="image-skeleton"
	/>
);

export default ImageSkeleton;
